import React from "react";

import { surveyCategoryHeader, categoryToggle } from "./survey-session-category-title.module.scss";

export interface ISurveySessionCategoryTitle {
    children?: string;
    categoryId: number;
    isCollapsed: boolean;
    onToggle: (categoryId: number) => void;
}

export default function SurveySessionCategoryTitle({
    children,
    categoryId,
    isCollapsed,
    onToggle,
}: ISurveySessionCategoryTitle) {
    const handleToggle = () => {
        onToggle(categoryId);
    };

    return (
        <div className={surveyCategoryHeader}>
            <span>{children}</span>
            <button className={categoryToggle} type="button" onClick={handleToggle}>
                {isCollapsed ? "Rozwiń" : "Zwiń"}
            </button>
        </div>
    );
}
